import { api } from "./contract";
import { getUserPreferencesResponse, setUserPreferenceRequest, setUserPreferenceResponse } from "./preferences.dto";

export const getUserPreferences = api("GET", "/user/preferences").withResponse(getUserPreferencesResponse);

export const setUserPreference = api("PUT", "/user/preferences/:key").withRequest(setUserPreferenceRequest).withResponse(setUserPreferenceResponse);
